import VueI18n from '@/i18n';

const t = (key) => VueI18n.t(key);

export const EXCLUSIVE_RESPONSE_OPTIONS = {
  no: 'word.no',
  not_applicable: 'phrase.not_applicable',
  dont_know: 'phrase.dont_know',
  none_of_the_above: 'phrase.none_of_the_above',
  prefer_not_to_answer: 'phrase.prefer_not_to_answer',
};

export const parseItemTitleReplaceKeys = (itemTitle, organisationName) => itemTitle.replace('$organisation_name', organisationName);
export const formattedItemText = (text) => text
  .replace(/__([^_]+)__/g, '<u>$1</u>') // Underline (__text__);
  .replace(/\*([^*_]+)\*/g, '<strong>$1</strong>') // Bold (*text*)
  .replace(/_([^_]+)_/g, '<em>$1</em>') // Italic (_text_)
  .replace(/~([^~]+)~/g, '<del>$1</del>'); // Strikethrough (~text~)

export const cleanedItemText = (text) => text
  .replace(/__([^_]+)__/g, '$1') // Underline (__text__);
  .replace(/\*([^*_]+)\*/g, '$1') // Bold (*text*)
  .replace(/_([^_]+)_/g, '$1') // Italic (_text_)
  .replace(/~([^~]+)~/g, '$1'); // Strikethrough (~text~)

export const isNumeric = (renderType) => renderType === 'stars';
export const isMultiChoice = (renderType) => renderType === 'check_boxes';
export const isMedia = (renderType) => renderType === 'media';
export const isSingleChoice = (renderType) => ['dropdown', 'radio_buttons'].includes(renderType);
export const isChoice = (renderType) => isMultiChoice(renderType) || isSingleChoice(renderType);
export const getChoiceDisplayValue = (value) => {
  if (Object.keys(EXCLUSIVE_RESPONSE_OPTIONS).includes(value)) {
    return t(EXCLUSIVE_RESPONSE_OPTIONS[value]);
  }
  return value;
};
